import './style.scss';

import React from 'react';
import Typed from 'typed.js';

class Typewriter extends React.Component {
  componentDidMount() {
    const selector = '#' + this.props.id;
    this.typed = new Typed(selector, { ...this.props });
  }

  render() {
    return <span id={this.props.id} />;
  }
}

export default Typewriter;



// WEBPACK FOOTER //
// ./shared/components/ui/typewriter/index.js